import { OC } from "../../utils";
import { ClientDiscountCode } from "./schema";

export const discountCodeContract = OC.router({
  get: OC.input(ClientDiscountCode.Get).output(ClientDiscountCode.DiscountCode),
});
